<template>
    <v-select placeholder="Select Network" bg-color="#21242C" :items="networkOptions" variant="solo" :menu-props="{
        contentClass: 'select-background-color',
            eager: true,
            maxHeight: 'auto',
            closeOnContentClick: true,
            openDelay: 0,
            closeDelay: 0
        }" density="compact" hide-details item-title="name" item-value="id"
        v-model="selectedNetwork" style="width: 170px;">
    </v-select>
</template>

<script>
import { computed } from 'vue';
import { useAppConfigStore } from "@/store/AppConfigStore";
import { OfferStore } from '@/store/offerStore';

export default {
    name: "OfferNetworkSelector",
    setup() {
        const offerStore = OfferStore();
        const appConfigStore = useAppConfigStore();
        const networkOptions = computed(() => {
            // Filter out invalid networks and ensure unique IDs
            const validNetworks = appConfigStore.networks.filter(network => 
                network && network.id !== undefined && network.name !== null
            );
            return [{ id: null, name: 'All Networks' }, ...validNetworks];
        });

        const selectedNetwork = computed({
            get: () => offerStore.offersParameters.network,
            set: (value) => {
                offerStore.offersParameters.network = value;
            }
        });

        // Set default network to null (All Networks) if not already set
        if (offerStore.offersParameters.network === undefined) {
            offerStore.offersParameters.network = null;
        }

        return { offerStore, networkOptions, selectedNetwork };
    },
}
</script>
